import React, { useState, useEffect } from 'react';
import './styles.css';
import { ArrowUp2, ArrowDown2 } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
function JoinTheClub() {
    const navigate = useNavigate();
    const userTypesList = [
        { id: 0, name: 'Club Personas',url:'/formPerson'},
        { id: 1, name: 'Doctor',       url:'/formDoctor'},
        { id: 2, name: 'Administrador',url:'/formAdmin'},
    ]
    const [isShowingList, setIsShowingList] = useState(false)
    const [currentTypeSelected, setcurrentTypeSelected] = useState(null);

    function selectType(value) {
        if (value?.id === currentTypeSelected?.id) return;
        setcurrentTypeSelected(value)
        setIsShowingList(false)
    }
    
    function Intro(){
        setIsShowingList(false)
        navigate( currentTypeSelected?.url)
    }

    useEffect(() => {
        setcurrentTypeSelected(userTypesList[0])
    }, [])

    return (
        <div className='joinTheClub'>
            <div className={` joinTheClubContainer ${isShowingList ? 'joinTheClubContainerOpen' : 'joinTheClubContainerClose'}`}>
                <div className='joinTheClubChoosed'>
                    <p className='joinTheClubChoosedText'>{currentTypeSelected?.name}</p>
                    <div className='joinTheClubChoosedBtn' onClick={() => setIsShowingList(!isShowingList)}>
                        {isShowingList
                            ? <ArrowUp2 size="20" color="#104172" />
                            : <ArrowDown2 size="20" color="#104172"
                            />
                        }
                    </div>
                </div>
                <div className='joinTheClubBtn' onClick={()=>Intro()}>
                    <p className='joinTheClubBtnText'>Entrar</p>
                </div>
            </div>
            <div className={`joinTheClubListContainer ${isShowingList ? 'joinTheClubListContainerOpen' : 'joinTheClubListContainerClose'}`}>
                {userTypesList.map((index, key) => {
                    return (
                        <div key={key} className='joinTheClubListContainerOption' onClick={() => selectType(index)}>
                            <p className='joinTheClubListContainerOptionText'>{index?.name}</p>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default JoinTheClub;